import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[eaNumericInput]',
  standalone: false,
})
export class EaNumericInputDirective {
  constructor(private el: ElementRef<HTMLInputElement>) {}

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    const allowedKeys = [
      'Backspace',
      'Delete',
      'Tab',
      'Escape',
      'Enter',
      'ArrowLeft',
      'ArrowRight',
      'ArrowUp',
      'ArrowDown',
      'Home',
      'End',
    ];
    if (allowedKeys.includes(event.key)) {
      return;
    }
    if (
      (event.ctrlKey || event.metaKey) &&
      ['a', 'c', 'v', 'x'].includes(event.key.toLowerCase())
    ) {
      return;
    }
    if (!/^[0-9.,]$/.test(event.key)) {
      event.preventDefault();
      return;
    }
    if ((event.key === '.' || event.key === ',') && this.el.nativeElement.value.includes('.')) {
      event.preventDefault();
    }
  }

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    this.sanitize();
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): void {
    event.preventDefault();
    const pasted = event.clipboardData?.getData('text') ?? '';
    const sanitized = pasted.replace(/[^0-9.,]/g, '').replace(/,/g, '.');
    document.execCommand('insertText', false, sanitized);
  }

  private sanitize(): void {
    const input = this.el.nativeElement;
    const replaced = input.value.replace(/[^0-9.,]/g, '').replace(/,/g, '.');
    const parts = replaced.split('.');
    const sanitized = parts.length > 1 ? parts[0] + '.' + parts.slice(1).join('') : replaced;
    if (input.value !== sanitized) {
      input.value = sanitized;
      input.dispatchEvent(new Event('input'));
    }
  }
}
